import { Navigate, useLocation } from "react-router";

/** Preserves query string when redirecting legacy `/cadastro/clinica/*` invite links to `/cadastro/multi/*`. */
export default function CadastroLegacyRedirect({ to }: { to: string }) {
    const location = useLocation();
    return <Navigate to={`${to}${location.search}${location.hash}`} replace />;
}
